import * as React from "react";
import type { SVGProps } from "react";
const SvgDetailsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="details_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M192 320a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm0 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm64 192a64 64 0 1 1-128 0 64 64 0 0 1 128 0zm128-512a42.667 42.667 0 0 0 42.667 42.667h426.666a42.667 42.667 0 1 0 0-85.334H426.667A42.667 42.667 0 0 0 384 256zm0 256a42.667 42.667 0 0 0 42.667 42.667h426.666a42.667 42.667 0 1 0 0-85.334H426.667A42.667 42.667 0 0 0 384 512zm42.667 298.667a42.667 42.667 0 1 1 0-85.334h426.666a42.667 42.667 0 1 1 0 85.334H426.667z"
    />
  </svg>
);
export default SvgDetailsIcon;
